import { Box, Paper, Typography } from '@mui/material'
import { BaseImage } from '../baseImage/baseImage'

export const SummarySection = ({ children, label, sx, ...props }) => {
  return (
    <Paper
      elevation={0}
      {...props}
      sx={{
        ...sx,
      }}
    >
      <Typography
        size="1.25rem"
        fontWeight={800}
        bgcolor="tertiary.main"
        width="fit-content"
        color="white"
        px={2}
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: '8px 16px',
          gap: '12px',
          borderRadius: '20px 20px 0 0',
          boxShadow: '-8px 8px 0px #E3BDC2',
          mb: 0,
        }}
        mb={0}
      >
        <BaseImage
          src="/images/icon-summary.png"
          alt="Summary icon"
          width={30}
          height={30}
        />
        {label}
      </Typography>

      <Box
        elevation={0}
        sx={{
          borderRadius: '0 20px 20px 20px',
          border: '1.5px solid',
          borderColor: 'tertiary.main',
          padding: '16px',
          bgcolor: 'white',
          color: 'primary.main',
          overflow: 'hidden',
          boxShadow: '-8px 8px 0px #E3BDC2',
        }}
      >
        {children}
      </Box>
    </Paper>
  )
}
